/**
 * Minimal Markdown → HTML for host insertion (Word `insertHtml`).
 * Covers the basics the assistant emits (paragraphs, bold/italic/code,
 * blockquotes, bullet lists). Swap for a full parser when needed.
 */
export function markdownToHtml(md: string): string {
  const escape = (s: string) =>
    s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

  const inline = (s: string) =>
    escape(s)
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.+?)\*/g, '<em>$1</em>')
      .replace(/`(.+?)`/g, '<code>$1</code>')

  const out: string[] = []
  let list: string[] | null = null
  const flush = () => {
    if (list) {
      out.push(`<ul>${list.join('')}</ul>`)
      list = null
    }
  }

  for (const raw of md.split('\n')) {
    const line = raw.trimEnd()
    if (!line.trim()) {
      flush()
      continue
    }
    if (/^[-*]\s+/.test(line)) {
      ;(list ??= []).push(`<li>${inline(line.replace(/^[-*]\s+/, ''))}</li>`)
      continue
    }
    flush()
    if (line.startsWith('> ')) {
      out.push(`<blockquote>${inline(line.slice(2))}</blockquote>`)
    } else {
      out.push(`<p>${inline(line)}</p>`)
    }
  }
  flush()
  return out.join('')
}
